<template>
    <div class="row">
        <div class="col-lg-12 mb-4">
            <div class="box collapse" id="collapseBlock">

             <AdvancedSearch
                 :key="componentKey"
                 @search="extraSearch"
                 @reset="resetExtraFilters"
             />

            </div>
        </div>
        <div v-if="loading" class="lds-dual-ring"></div>
        <div v-else class="col-lg-12 mb-4">
            <div class="box">
                <div class="box-offset">
                    <div class="buttons--row  mb-4">
                        <div class="search--block">
                            <button
                                class="search--block-btn"
                                type="submit"
                                @click.prevent="handleSearch"
                            >
                                <img src="/img/svg/icons-search.svg" alt=""></button>
                            <input
                                type="search"
                                name="search"
                                class="search--block-txt"
                                placeholder="Search by Name"
                                v-model="filters.name"
                                @input="handleSearch"
                            />
                        </div>
                        <button
                            v-if="possibilityToExport"
                            class="btn btn--outline-primary btn--middle"
                            @click="exportUsersIds">
                            <img src="/img/svg/excel.svg" alt="export">
                        </button>
                        <a href="/master-admin/applicants/add" class="btn btn--outline-primary btn--middle">+ Add</a>

                        <a href="#" class="btn btn--secondary btn--middle" data-toggle="collapse" data-target="#collapseBlock" aria-expanded="false" aria-controls="collapseBlock">
                            Add Filter <i class="fa fa-chevron-down ml-2"></i>
                        </a>
                    </div>
                    <div class="buttons--row justify-content-lg-between">
                        <div class="filter-wrap" >
                            <label for="" class="reg-label mr-2">Filter:</label>
                            <div class="form-group form-group-2 mb-0" style="flex-grow: 1">
                                <select class="custom-select" v-model="filters.status" @change="getApplicantsData(filters)">
                                    <option value="all" selected="">All</option>
                                    <option value="active" selected="">Active</option>
                                    <option value="inactive" selected="">Inactive</option>
                                    <option value="pending" selected="">In process</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="table-holder table-responsive">
                        <table class="table">
                            <thead>
                            <tr>
                                <th>
                                    <div class="form-group form-group-1 mb-0">
                                        <div class="form-check">
                                            <input
                                                class="form-check-input-checkbox"
                                                type="checkbox"
                                                name="12"
                                                id="home-office"
                                                v-model="checkAll"
                                                @change="toggleAll">
                                            <label class="form-check-label" for="home-office"></label>
                                        </div>
                                    </div>
                                </th>
                                <th>
                                    <nobr>
                                        <a href="javascript:void(0)" @click.prevent="changeSortList('name')">First Name<i class="fas fa-sort"></i></a></nobr></th>
                                <th>
                                    <nobr>
                                        <a href="javascript:void(0)" @click.prevent="changeSortList('last_name')">Last Name<i class="fas fa-sort"></i></a>
                                    </nobr>
                                </th>
                                <th>Tags</th>
                                <th>Stages</th>
                                <th>
                                    <nobr>
                                        <a href="javascript:void(0)" @click.prevent="changeSortList('position')">
                                            Position <i class="fas fa-sort"></i>
                                        </a>
                                    </nobr>
                                </th>
                                <th>
                                    <nobr>
                                        <a href="javascript:void(0)" @click.prevent="changeSortList('date_applied')">
                                            Date Applied <i class="fas fa-sort"></i>
                                        </a>
                                    </nobr>
                                </th>
                                <th>
                                    <nobr>
                                        <a href="javascript:void(0)" @click.prevent="changeSortList('address')">
                                            City, State, Zip <i class="fas fa-sort"></i>
                                        </a>
                                    </nobr>
                                </th>
                                <th class="text-right">Action</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(applicant, index) in applicants" :key="index">
                                <td>
                                    <div class="form-group form-group-1">
                                        <div class="form-check">
                                            <input
                                                class="form-check-input-checkbox"
                                                type="checkbox"
                                                name="12"
                                                :id="'checkbox_' + index"
                                                :value="applicant.id"
                                                v-model="export_user_ids"
                                                @change="updateCheckedItems"
                                            >
                                            <label class="form-check-label" :for="'checkbox_' + index"></label>
                                        </div>
                                    </div>
                                </td>
                                <td class="color--text">
                                    <a :href="`/master-admin/applicants/${applicant.id}/show`"><b>{{ applicant.name }}</b></a>
                                </td>
                                <td class="color--text">
                                    <a :href="`/master-admin/applicants/${applicant.id}/show`"><b>{{ applicant.last_name }}</b></a>
                                </td>
                                <td v-if="applicant.tags.length > 0">
                                    <div class="tags-list" >
                                        <div class="tag-wrap">
                                            {{applicant.tags[0]?.name}}
                                        </div>
                                        <a class="action-link dropdown-toggle" data-toggle="dropdown" href="#"><b>{{applicant.tags.length}}</b> tags</a>
                                        <div class="dropdown-menu">
                                            <div class="tags-wrap" >
                                                <div class="tag-item" v-for="tag in applicant.tags">{{ tag.name }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                                <td v-else></td>
                                <td>
                                    {{applicant.stages}}
                                </td>
                                <td>
                                    {{ applicant.position?.title ?? '' }}
                                </td>
                                <td>
                                    <div v-if="applicant.date_applied" class="color--text-gray">
                                        {{ calculateDate(applicant.date_applied)}}
                                    </div>
                                    <div v-else class="color--text-gray">N/A</div>
                                </td>
                                <td>
                                    {{ applicant.user_address?.city ?? ''}} {{ applicant.user_address?.state ?? ''}} {{ applicant.user_address?.zip ??'' }}
                                </td>
                                <td class="text-right">
                                    <div class="action-block">
                                        <div class="actions-drop dropdown-settings">
                                            <a
                                                class="nav-link dropdown-toggle"
                                                data-toggle="dropdown"
                                                href="#"
                                                id="dropdown-settings"
                                            >
                                                <img src="/img/svg/three-dots.svg" alt="">
                                            </a>
                                            <div class="dropdown-menu" aria-labelledby="dropdown-settings">
                                                <a
                                                    class="dropdown-item"
                                                    :href="`/master-admin/applicants/${applicant.id}/show?tab=Notes`">
                                                    <em class="icon" style="background-image: url(/img/icon-pen.png);"></em>Notes
                                                </a>

                                                <a class="dropdown-item"
                                                   :href="`/master-admin/applicants/${applicant.id}/print`"
                                                   target="_blank"
                                                >
                                                    <em class="icon" style="background-image: url(/img/icon-print.png);" />
                                                    Print Application
                                                </a>

                                                <a
                                                    class="dropdown-item"
                                                    href="javascript:void(0)"
                                                    @click="showCustomModal('email', applicant.id, applicant.name, applicant.last_name)">
                                                    <em class="icon" style="background-image: url(/img/icon-mail.png);"></em>Email
                                                </a>
                                            </div>
                                        </div>
                                        <button
                                            v-show="deletingApplicant"
                                            class="delete-link"
                                            @click="showDeleteModal(applicant.id)"
                                        >
                                            <img src="/img/svg/on.svg" alt="delete">
                                        </button>

                                        <ActionModal confirm-text="Yes" reject-text="No"
                                                     :modalId="getDeleteModalId(applicant.id)"
                                                     @confirm="deleteApplicant(applicant.id)">
                                            <template #body>
                                                <div class="text-center mb-4">
                                                    <h4>
                                                        Are you sure you want <br> to delete this item?
                                                    </h4>
                                                </div>
                                            </template>
                                        </ActionModal>
                                    </div>
                                </td>

                                <EmailModal
                                    :modal-id="getCustomModalId('email',applicant.id)"
                                    :applicant-email="applicant.email"
                                    :applicant-id="applicant.id"
                                    :responses="listOfPreconfiguredResponses"
                                />

                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="row align-items-center">
                        <Pagination
                            class="ml-3 mr-3"
                            :currentPage="pagination.current_page"
                            :lastPage="pagination.last_page"
                            @changeItemsPerPage="changeItemsPerPage"
                            @changePage="changePage"/>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import ApplicantsServices from "./services/ApplicantsServices";
import VueMultiSelect from "../../../../../resources/js/plugins/VueMultiSelect.vue";
import Pagination from "../../../../../resources/js/components/Pagination.vue";
import EmailModal from "../../../../../resources/js/components/EmailModal.vue";
import ActionModal from "../../../../../resources/js/components/ActionModal.vue";
import DateConverter from "../../../../../resources/js/mixins/DateConverter";
import PaginationHandler from "../../../../../resources/js/mixins/PaginationHandler";
import SortDirectionHandler from "../../../../../resources/js/mixins/SortDirectionHandler";
import ModalHandler from "../../../../../resources/js/mixins/ModalHandler";
import AdvancedSearch from "./AdvancedSearch.vue";
import ResponsesServices from "../../../PreconfiguredResponses/resources/js/services/ResponsesServices";
import ExportHandler from "../../../../../resources/js/mixins/ExportHandler";
import _ from "lodash";
import SiteClientsService from "../../../SitesClients/resources/js/services/SiteClientsService";

export default {
    name: 'ApplicantsList',
    props: {
       possibilityToExport: {
           type: Boolean,
           required: true
       },
        deletingApplicant: {
           type: Boolean,
            required: true
        }
    },
    components: {
        AdvancedSearch,
        ActionModal,
        EmailModal,
        Pagination,
        VueMultiSelect,
    },
    mixins: [
        DateConverter,
        PaginationHandler,
        SortDirectionHandler,
        ModalHandler,
        ExportHandler,
    ],
    data() {
        return {
            componentKey: 0,
            loading: true,
            applicants: [],
            listOfPreconfiguredResponses: [],
            checkAll: false,
            export_user_ids: [],
            pagination: {
                current_page: 1,
                last_page: 1,
            },
            filters: {
                name: '',
                page: 1,
                perPage: 10,
                status: 'all',
                sortBy: "date_applied",
                sortDir: 'desc',
            }
        }
    },
    methods: {
        handleSearch() {
            this.filters.page = 1
            this.delayedSearch();
        },
        delayedSearch: _.debounce(function() {
            this.getApplicantsData(this.filters)
        }, 500),

        async getResponsesList() {
            try {
                const {data: response} = await ResponsesServices.getListWithDefaultFilters()
                this.listOfPreconfiguredResponses = response.data

            } catch (error) {
                this.$showErrorMessage();
            }
        },
        resetExtraFilters(extraFilters) {
            this.getApplicantsData(extraFilters)
            this.componentKey += 1
        },
        extraSearch(extraFilters) {
            this.filters = {
                ...this.filters,
                ...extraFilters
            }
            this.getApplicantsData(this.filters)
        },
        getList(filters) {
            this.getApplicantsData(filters)
            console.log(filters)
        },
        async getApplicantsData(filters) {
            try {
                const { data: response} = await ApplicantsServices.getApplicantsList(filters)
                this.applicants = response.data
                this.pagination.current_page = response.current_page
                this.pagination.last_page = response.last_page
                this.loading = false
            } catch (error) {
                this.$handleErrors(error)
            }
        },
        async exportUsersIds() {
            const dataToSend = {
                'export_user_ids': this.export_user_ids
            };
                try {
                    const response =  await ApplicantsServices.exportUsersData(dataToSend)
                    this.createExportFile(response, 'applicants_export_')

                } catch(error) {
                    console.error(error)
                    this.$showErrorMessage();
                }
        },
        toggleAll() {
            if (this.checkAll) {
                this.export_user_ids = this.applicants.map(applicant => applicant.id);
            } else {
                this.export_user_ids = [];
            }
        },
        updateCheckedItems() {
            if (this.export_user_ids.length === this.applicants.length) {
                this.checkAll = true;
            } else {
                this.checkAll = false;
            }
        },
        async deleteApplicant(id) {
            this.$showLoadingMessage()
            this.applicants = this.applicants.filter((applicant) => applicant.id !== id)
            try {
                await ApplicantsServices.deleteApplicant(id)
                this.$showSuccessMessageDelete();
            } catch (error) {
                this.$showErrorMessage('The Applicant was not deleted. Please try again');
            }
        }

    },
    mounted() {
        this.getApplicantsData(this.filters)
        this.getResponsesList()
    },

}

</script>

<style scoped>

</style>
